export const Constant = {
  interval: 15 * 60 * 1000, // 15 minutes
};

export const formatMoney = (value: string | number) => {
  if (!value) return '0';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return numValue.toLocaleString('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
};